import type { Phrases } from '../common/Phrases.d';
import type { ButtonGroupOption } from '../../../components/react-hook-form/ButtonGroup';

import React, {
	useMemo,
} from 'react';
// import { ButtonGroup } from '../../../components/react-hook-form/ButtonGroup';
import { ButtonRadioGroup } from '/react4xp/components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	SERVICES_FIELD_NAME,
	SERVICES_FREETEXT_FIELD_NAME,
	FIELD_VALUE_NUMBER_OF_PEOPLE_GOT_REACTIONS,
} from './constants';


export const NumberOfPeopleGotReactionsButtonGroup = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {

	const memoedDescription = useMemo(() => {
		return phrases['notificationForm.term.chooseOne'];
	}, [phrases]);

	const memoedLabel = useMemo(() => {
		return phrases['notificationForm.services.numberOfPeopleGotReactionsField.label'];
	}, [phrases]);

	const memoedOptions: ButtonGroupOption[] = useMemo(() => {
		return [{
			label: phrases['notificationForm.services.numberOfPeopleGotReactionsField.value.one'],
			value: FIELD_VALUE_NUMBER_OF_PEOPLE_GOT_REACTIONS.ONE,
		},{
			label: phrases['notificationForm.services.numberOfPeopleGotReactionsField.value.several'],
			value: FIELD_VALUE_NUMBER_OF_PEOPLE_GOT_REACTIONS.SEVERAL,
		},{
			label: phrases['notificationForm.services.numberOfPeopleGotReactionsField.value.unknown'],
			value: FIELD_VALUE_NUMBER_OF_PEOPLE_GOT_REACTIONS.UNKNOWN,
		}];
	}, [phrases]);

	return (
		<ButtonRadioGroup
			afterClick={({ newValue, setValue }) => {
				if (newValue !== FIELD_VALUE_NUMBER_OF_PEOPLE_GOT_REACTIONS.SEVERAL) {
					// Yes, empty string can be set on optional text fields.
					setValue(SERVICES_FREETEXT_FIELD_NAME.NUMBER_OF_PEOPLE_GOT_REACTIONS_OTHER, '', { shouldValidate: true });
				}
			}}
			className='z-0'
			description={memoedDescription}
			label={memoedLabel}
			name={SERVICES_FIELD_NAME.NUMBER_OF_PEOPLE_GOT_REACTIONS}
			options={memoedOptions}
		/>
	);
};
